module.exports = __webpack_public_path__ + "static/img/12.817e4a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/12.png
// module id = UZs8
// module chunks = 0